// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CreatePlaylist_wrapper__42o1L","newBtn":"CreatePlaylist_newBtn__28E4X"};